import moment from "moment";
import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../contexts/AppContext";
import Loader from "./Loader";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import undrawProfile from "../img/undraw_profile.svg";
import { errorResponseMessage } from "../shared/const.prop";

const RescheduleWeeklySession = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [reason, setReason] = useState("");
  const [newSlot, setNewSlot] = useState({});
  const [loading, setLoading] = useState(true);
  const [slotData, setSlotData] = useState([]);
  const dispatch = useDispatch();

  const { user } = authContext;

  const userId = user?.userId || user?.data?.data?.userId;

  var isMentor = userId === data?.mentorId;

  useEffect(() => {
    fetchSlotData();
    dispatch(getActiveChatNotificationCount());
  }, []);

  const formatTimeWithData = (time) => {
    return moment.utc(time).format("DD/MM/YYYY h:mm A");
  };

  const formatTime = (time) => {
    return moment.utc(time).format("h:mm A");
  };

  const fetchSlotData = async () => {
    try {
      const getSlotData = await axiosHttp.get(
        `reschedule-appointment/${data.id}/weekly?startTime=${data?.start_time}`
      );
      if (getSlotData.status === 200) {
        setSlotData(getSlotData.data.slots);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      console.log(error);
    }
  };

  const rescheduleSession = async () => {
    setLoading(true);
    let payload = {
      comment: reason,
      oldStartTime: data.start_time,
      oldEndTime: data.end_time,
      newStartTime: newSlot.start_time,
      newEndTime: newSlot.end_time,
    };

    try {
      const getRescheduleSession = await axiosHttp.post(
        isMentor
          ? `reschedule-request/${data.id}`
          : `reschedule-appointment/${data.id}/weekly`,
        { ...payload }
      );
      if (getRescheduleSession.status === 201) {
        dispatch(getActiveNotificationCount());

        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      let { response } = e;
      setLoading(false);
      if (response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: response?.data?.error,
          type: "error",
        });
        setLoading(false);
        appContext.updateModalState();
      }
      if (response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        setLoading(false);
        appContext.updateModalState();
      }

      //console.error(e);
    }
  };

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    const selectedOption = slotData.find(
      (option) => option.start_time === selectedValue
    );
    setNewSlot(selectedOption);
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="join-session-modal">
      <div className="modal-header">
        {/* <h5 className="modal-title" id="exampleModalLongTitle">
          <img
            className="img-profile rounded-circle mr-3"
            src={data?.mentorPicUrl || undrawProfile}
          />
          <span className="ml-3 profile-name">{data?.mentorName}</span>
        </h5> */}
        <h3 className="w-100 text-center mb-0">Reschedule</h3>
      </div>
      <div className="modal-body">
        <div
          className="d-flex justify-content-center align-items-start"
          id="exampleModalLongTitle"
        >
          <img
            className="img-profile rounded-circle mr-3"
            src={data?.mentorPicUrl || undrawProfile}
            onClick={() => {
              navigate(`../${data?.mentorUsername}`);
            }}
          />
          <div>
            <span
              className="profile-name"
              onClick={() => {
                navigate(`../${data?.mentorUsername}`);
              }}
            >
              {data?.mentorName}
            </span>
            <p className="mb-0">
              <strong>Session Details:</strong>
            </p>
            <p className="mb-0">
              <strong>Service Name: </strong> {data?.serviceName},{" "}
              <strong>Date: </strong>{" "}
              {moment.utc(data.end_time).format("DD/MM/YYYY")},{" "}
              <strong>Start Time: </strong>
              {formatTime(data.start_time)}, <strong>End Time: </strong>
              {formatTime(data.end_time)}
            </p>
          </div>
        </div>
        {/* <div className="session-card mb-4 mt-4">
          <div className="row">
            <div className="col-md-3">
              <p className="box-txt mb-0 mt-2">
                {" "}
                {moment.utc(data.end_time).format("DD/MM/YYYY")}
              </p>
            </div>
            <div className="col-md-8">
              <div className="d-flex">
                <input
                  type="text"
                  className="form-control border-0 "
                  placeholder="9:00 AM"
                  value={formatTime(data.start_time)}
                />
                <span className="mt-2 mx-3">-</span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="10:00 PM"
                  value={formatTime(data.end_time)}
                />
              </div>
            </div>
          </div>
        </div> */}
        <div className="form-group">
          <lable>Reason</lable>
          <select
            className="form-control"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Select</option>
            <option value=" No longer interested in the session">
              {" "}
              No longer interested in the session
            </option>
            <option value="Expertise not available">
              Expertise not available
            </option>
            <option value=" Personal reasons">Personal reasons</option>
            <option value="Application interface issue">
              Application interface issue
            </option>
            <option value=" Found another expert">Found another expert</option>
            <option value="Others">Others</option>
          </select>
        </div>
        <div class="row mt-4">
          <div className="col-md-12">
            <label>Select Date</label>
            <select
              name="time"
              class="form-control"
              value={newSlot ? newSlot.start_time : ""}
              onChange={handleOptionChange}
            >
              <option value="">Please Select</option>
              {slotData.map((item) => {
                if (item.status === "Available") {
                  return (
                    <option
                      key={item.start_time}
                      value={item.start_time}
                    >{` ${formatTimeWithData(
                      item.start_time
                    )} - ${formatTimeWithData(item.end_time)}`}</option>
                  );
                }
              })}
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-2 mb-3 justify-content-center">
        <button
          type="button"
          class="btn btn-outline-primary prime-btn mr-3"
          data-dismiss="modal"
          onClick={() => appContext.updateModalState()}
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-outline-primary modal-btn"
          onClick={rescheduleSession}
          disabled={reason === "" || newSlot.length === 0}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default RescheduleWeeklySession;
